var React = require('react');

function CloseInline (props) {
    return React.createElement("svg",props,[React.createElement("line",{"x1":"2.69736","y1":"2.18359","x2":"19.4911","y2":"18.9774","stroke":"current","strokeWidth":"2.6","strokeLinecap":"round","key":0}),React.createElement("line",{"x1":"2.85889","y1":"18.977","x2":"19.6527","y2":"2.18317","stroke":"current","strokeWidth":"2.6","strokeLinecap":"round","key":1})]);
}

CloseInline.defaultProps = {"width":"22","height":"21","viewBox":"0 0 22 21","fill":"none"};

module.exports = CloseInline;

CloseInline.default = CloseInline;
